import AppBtnShare from '../app-btn-share'
import AppImgBg from '../app-img-bg'
import AppTextMask from '../app-text-mask'

// URL list
import URL from '../../../config.url'

export default
{
    name: 'app-news-slideshow-mobile',

    components:
    {
        AppBtnShare,
        AppImgBg,
        AppTextMask
    },

    watch:
    {
        activeIndex: 'onActiveIndexChange'
    },

    props:
    {
        news: { type: Array, default: [] },
        share: { type: Object, default: {} },
        footer: { type: String, default: 'Read more' }
    },

    data()
    {
        return {
            activeIndex: 0
        }
    },

    created()
    {
        this.PIXEL_STEP = 10

        // Mousewheel
        this._isPointerDown = false
        this._pointerX = 0
        this._pointerStartX = 0
        this._pointerY = 0
        this._pointerStartY = 0
        this._pointerXOffset = 50
        //

        document.addEventListener('keydown', this._onKeydown)
    },

    mounted()
    {
        this.$slides = this.$el.querySelectorAll('.js-slideshow-item')
    },

    destroyed()
    {
        document.removeEventListener('keydown', this._onKeydown)
    },

    methods:
    {
        // EVENTS
        _onKeydown(event)
        {
            // Right
            if (event.keyCode === 39)
            {
                this.changeActiveIndexTo(this.activeIndex + 1)
            }
            // Left
            else if (event.keyCode === 37)
            {
                this.changeActiveIndexTo(this.activeIndex - 1)
            }
        },

        // SCROLL
        onTouchDown(event)
        {
            this._isPointerDown = true

            this._pointerStartY = event.touches[0].clientY
            this._pointerStartX = event.touches[0].clientX

            this._pointerY = this._pointerStartY
            this._pointerX = this._pointerStartX
        },

        onTouchMove(event)
        {
            if (!this._isPointerDown) return

            if (Math.abs(this._pointerStartX - event.touches[0].clientX) > 10)
            {
                event.preventDefault()
            }

            this._pointerY = event.touches[0].clientY
            this._pointerX = event.touches[0].clientX
        },

        onTouchEnd(/* event */)
        {
            if (!this._isPointerDown) return

            this._isPointerDown = false

            if (Math.abs(this._pointerStartX - this._pointerX) > 10)
            {
                if (this._pointerX > this._pointerStartX)
                {
                    this.changeActiveIndexTo(this.activeIndex - 1)
                }
                else
                {
                    this.changeActiveIndexTo(this.activeIndex + 1)
                }
            }
        },

        // WATCHERS
        onActiveIndexChange()
        {
            for (let i = 0, l = this.$slides.length; i < l; i += 1)
            {
                this.$slides[i].style.transform = `translateX(${this.activeIndex * -100}%) translateZ(0)`
            }
        },

        // HTML ACTIONS
        changeActiveIndexTo(index)
        {
            // Redirect to news
            if (this.activeIndex === index)
            {
                this.$router.push(this.getArticleUrlBySlug(this.news[this.activeIndex].slug))
            }

            if (index >= 0 && index < this.news.length)
            {
                this.activeIndex = index
            }
        },

        _shorten(text, length)
        {
            if (text.length > length)
            {
                text = text.substr(0, length - 3)
                text = text.substr(0, Math.min(text.length, text.lastIndexOf(' '))) + '...'
            }

            return text
        },

        _getResumeSubtracted(index, length)
        {
            return this.news[index].resume.substr(0, length) + '...'
        },

        getArticleUrlBySlug(slug)
        {
            return URL.page.article.replace(':slug', slug)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-news-slideshow-mobile/script.js